import { useQuery } from '@tanstack/vue-query'
import { Ref } from 'vue'

import { explorerPlusApi } from '~/api/client'
import { PROFILE_QUERY_KEYS } from '~/constants/query-keys/profile.constant'
import { ProfileProjectDetailModel } from '~/types/model/profile/project-detail.model'
import { SidebarTokenMenuModel } from '~/types/model/profile/token.list.model'
import { TokenDetailModel } from '~/types/model/profile/token.model'
import { TokenPriceModel, toTokenPriceModel } from '~/types/model/profile/token.price.model'
import { CTokenPriceModel } from '~/types/model/profile/token-price.model'
import { tokenChartPeriodType } from '~/types/period.type'

export const useProjectTokenDetail = (tokenId: string) => {
  return useQuery([ ...PROFILE_QUERY_KEYS.TOKEN, tokenId ], async (): Promise<TokenDetailModel> => {
    return explorerPlusApi.profileController.getProjectTokenDetail({ tokenId }).then(res => {
      return new TokenDetailModel(res)
    })
  })
}

export const useTokenPrice = (tokenId: string, period: Ref<tokenChartPeriodType>) => {
  return useQuery([ ...PROFILE_QUERY_KEYS.TOKEN_PRICE, tokenId, period ], async (): Promise<CTokenPriceModel> => {
    return explorerPlusApi.profileController.getTokenPrice({
      tokenId,
      period: period.value
    }).then(res => {
      return new CTokenPriceModel(res)
    })
  })
}

export const useProjectTokenList = () => {
  return useQuery([ ...PROFILE_QUERY_KEYS.TOKEN_LIST ], async () => {
    return explorerPlusApi.profileController.getProjectTokenList().then(res => {
      return res.map(token => new SidebarTokenMenuModel(token))
    })
  })
}

export const useProjectDetail = () => {
  return useQuery([ ...PROFILE_QUERY_KEYS.PROJECT ], async (): Promise<ProfileProjectDetailModel> => {
    return explorerPlusApi.profileController.getProjectDetail().then(res => {
      return new ProfileProjectDetailModel(res)
    })
  })
}